import { useState, useCallback, useRef, useEffect } from 'react';

// Simple auto-dismissing toast message, shared by Dashboard and EventsPage
// (both previously reimplemented this from scratch).
export function useToast(duration = 2200) {
    const [toast, setToast] = useState('');
    const timerRef = useRef(null);

    useEffect(() => () => clearTimeout(timerRef.current), []);

    const showToast = useCallback((message) => {
        clearTimeout(timerRef.current);
        setToast(message);
        timerRef.current = setTimeout(() => setToast(''), duration);
    }, [duration]);

    const hideToast = useCallback(() => {
        clearTimeout(timerRef.current);
        setToast('');
    }, []);

    return { toast, showToast, hideToast };
}
